import { c as _c } from "react/compiler-runtime";
/** CSS-only 3D bag: four faces on a rotating Y axis, label bars blurred on top. */
export function SpinningBag() {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      transform: "translateZ(26px)",
      backfaceVisibility: "hidden",
      clipPath: "polygon(7% 0,93% 0,100% 8%,95% 100%,5% 100%,0 8%)",
      background: "linear-gradient(112deg,#101113 0%,#232529 30%,#3B3E43 50%,#1A1C1F 72%,#0B0C0E 100%)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="absolute top-0 right-0 left-0 block h-[8%] border-white/15 border-b" style={{
      background: "repeating-linear-gradient(90deg,rgba(255,255,255,.10) 0 3px,rgba(0,0,0,0) 3px 7px)"
    }} />;
    t2 = <span className="absolute top-[15%] left-[14%] block h-[6%] w-[34%] rounded-[2px] bg-[rgba(176,30,36,.92)] blur-[5px]" />;
    t3 = <span className="absolute top-[33%] left-[16%] block h-[10%] w-[68%] rounded-[2px] bg-white/90 blur-[6px]" />;
    t4 = <span className="absolute top-[51%] left-[24%] block h-[7%] w-[52%] rounded-[2px] bg-white/55 blur-[6px]" />;
    t5 = <span className="absolute top-[65%] left-[20%] block h-[8%] w-[60%] rounded-[2px] bg-[#B01E24] blur-[6px]" />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute top-[2%] left-[8%] h-[96%] w-[84%]" style={t0}>{t1}{t2}{t3}{t4}{t5}<span className="absolute inset-0 block" style={{
        background: "linear-gradient(105deg,transparent 32%,rgba(255,255,255,.13) 46%,transparent 58%)"
      }} /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      transform: "rotateY(180deg) translateZ(26px)",
      backfaceVisibility: "hidden",
      clipPath: "polygon(7% 0,93% 0,100% 8%,95% 100%,5% 100%,0 8%)",
      background: "linear-gradient(112deg,#0B0C0E 0%,#1A1C1F 34%,#2B2D31 52%,#141518 74%,#08090A 100%)"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute top-[2%] left-[8%] h-[96%] w-[84%]" style={t7}><span className="absolute top-0 right-0 left-0 block h-[8%] border-white/10 border-b" style={{
        background: "repeating-linear-gradient(90deg,rgba(255,255,255,.07) 0 3px,rgba(0,0,0,0) 3px 7px)"
      }} /><span className="absolute top-[40%] left-[24%] block h-[8%] w-[52%] rounded-[2px] bg-white/30 blur-[7px]" /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute top-[2%] left-[calc(50%-26px)] h-[96%] w-[52px]" style={{
      transform: "rotateY(90deg) translateZ(min(20vw,88px))",
      backfaceVisibility: "hidden",
      background: "linear-gradient(90deg,#08090A,#26282C 38%,#4C4F54 52%,#1B1D20 70%,#060708)",
      clipPath: "polygon(0 1%,100% 1%,100% 99%,0 99%)"
    }} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="teaser-spin-bag -mt-[5%] relative h-[min(54%,370px)] w-[min(56vw,250px)]" aria-hidden="true">{t6}{t8}{t9}<div className="absolute top-[2%] left-[calc(50%-26px)] h-[96%] w-[52px]" style={{
        transform: "rotateY(-90deg) translateZ(min(20vw,88px))",
        backfaceVisibility: "hidden",
        background: "linear-gradient(90deg,#060708,#1B1D20 30%,#4C4F54 50%,#26282C 64%,#08090A)",
        clipPath: "polygon(0 1%,100% 1%,100% 99%,0 99%)"
      }} /></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
}